import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { formatWIB } from "@/lib/datetime";
import StickyHeader from "@/components/StickyHeader";

const ACTION_STYLE = {
    CREATE: "bg-emerald-100 text-emerald-700 border-emerald-300",
    UPDATE: "bg-blue-100 text-blue-700 border-blue-300",
    DELETE: "bg-rose-100 text-rose-700 border-rose-300",
    LOGIN: "bg-slate-100 text-slate-600 border-slate-300",
    LOGOUT: "bg-slate-100 text-slate-600 border-slate-300",
    CHANGE_PASSWORD: "bg-amber-100 text-amber-700 border-amber-300",
};

export default function AuditLog() {
    const [logs, setLogs] = useState([]);

    useEffect(() => {
        (async () => {
            try { const { data } = await api.get("/audit-logs"); setLogs(data); } catch {}
        })();
    }, []);

    return (
        <div className="max-w-6xl mx-auto px-6 lg:px-8 py-8 space-y-4">
            <StickyHeader>
            <div>
                <div className="text-[11px] uppercase tracking-widest text-slate-500 font-semibold">Keamanan</div>
                <h1 className="text-3xl font-extrabold tracking-tight text-slate-900" style={{ fontFamily: "Plus Jakarta Sans" }}>
                    Audit Log
                </h1>
                <p className="text-sm text-slate-500 mt-1">Riwayat semua perubahan data dan aktivitas login.</p>
            </div>
            </StickyHeader>

            <Card className="border-slate-200 shadow-sm overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="w-full compact">
                        <thead className="bg-slate-100">
                            <tr className="text-left text-xs uppercase tracking-wider text-slate-600 font-semibold">
                                <th>Waktu</th><th>Aktor</th><th>Aksi</th><th>Entitas</th><th>Detail</th>
                            </tr>
                        </thead>
                        <tbody>
                            {logs.map((l) => (
                                <tr key={l.id} className="border-t border-slate-200 hover:bg-slate-50">
                                    <td className="text-xs text-slate-500 whitespace-nowrap">{formatWIB(l.timestamp)}</td>
                                    <td className="font-mono text-xs">{l.actor_email}</td>
                                    <td>
                                        <span className={`inline-block px-2 py-0.5 rounded-full border text-[11px] font-semibold ${ACTION_STYLE[l.action] || "bg-slate-100 text-slate-600 border-slate-300"}`}>
                                            {l.action}
                                        </span>
                                    </td>
                                    <td><Badge variant="outline">{l.entity}</Badge></td>
                                    <td className="text-xs text-slate-600">{l.detail || l.entity_id}</td>
                                </tr>
                            ))}
                            {logs.length === 0 && (
                                <tr><td colSpan={5} className="text-center py-10 text-slate-400">Belum ada aktivitas.</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </Card>
        </div>
    );
}
